import React from 'react'
import { 
	CSpinner,
} from '@coreui/react'

const MyLoader = (props) => {
	const {isShow} = props
	
	if(!isShow) return (<></>)
	
	return (
	<div className="position-fixed w-100 h-100 d-flex justify-content-center align-items-center"
		style={{zIndex:1091,backgroundColor:"#6C778E55"}}>
		<CSpinner color="danger" className="fs-bold" style={{width:'3rem', height:'3rem'}}/>
	</div>
	)
}	

export default MyLoader